import * as Yup from "yup";
import { validationMessages } from "./validation";
import { validateTilDatoEfterEllerSammeSomFraDato } from "../util/validation";
export const DOWNLOAD_DATE_VALIDATION_SCHEMA = Yup.object({
  fromDate: Yup.date().nullable().required(validationMessages.required),
  toDate: Yup.date()
    .nullable()
    .required(validationMessages.required)
    .test("toDate", "Slutdato kan ikke være før startdato", function (val) {
      const {
        fromDate,
      }: {
        fromDate: Date | undefined;
      } = this.parent;
      return validateTilDatoEfterEllerSammeSomFraDato(fromDate, val);
    }),
});
